'use client';

import React, { FC, useState } from 'react';

import Image from '@/components/core/Image';
import ContactMe from '@/components/popups/ContactMe';
import { useTranslation } from '@/hooks/useTranslations';

import { TeamMemberType } from '.';

interface TeamMemberProps {
  member: TeamMemberType;
}

export const POSITIONS = {
  'Head of Business Development': 'Aboutus-SalesTeam-Position1',
  'Business Development Executive': 'Aboutus-SalesTeam-Position2',
};

const TeamMember: FC<TeamMemberProps> = ({ member }) => {
  const [showContactMeModal, setShowContactMeModal] = useState<undefined | TeamMemberType>(
    undefined
  );
  const { t } = useTranslation();

  const handleContactMe = () => {
    if (member) {
      setShowContactMeModal(member);
    }
  };

  return (
    <div className="ourTeamCardWrp">
      <div className="ourTeamCardImgCont">
        <div className="ourTeamCardImgContInner">
          <Image
            alt=""
            width={800}
            height={800}
            quality={100}
            src={member.logo}
            className="ourTeamCardImg"
            style={{
              backgroundColor: member?.bgColor ?? 'transparent',
            }}
          />
        </div>
      </div>
      <div className="ourTeamCardInfoWrp">
        <p className="ourTeamCardInfoTitle">{member.firstname}</p>
        <p className="ourTeamCardInfoSubText">{member.position}</p>
      </div>
      <div className="ourTeamCardButtonCase">
        <button
          className="button btnTypeMedium btnTypeGray fullWidth"
          onClick={() => handleContactMe()}
          id={`${member.firstname.toLowerCase()}-contact-me`}
        >
          <p className="mobBtnTxt">{t('Contactus-SalesTeam-Contactme-Button')}</p>
          {/*<i className="bc-i-go-to btnIcon btnIconSmall" />*/}
        </button>
      </div>
      <ContactMe member={showContactMeModal} onClose={() => setShowContactMeModal(undefined)} />
    </div>
  );
};

export default TeamMember;
